export default __webpack_public_path__ + "static/bariol_serif_bold_italic-webfont-af9ac98adb389d7a099b37e5dd00f778.ttf";